import { render, staticRenderFns } from "./changeUser.vue?vue&type=template&id=322e06d0"
import script from "./changeUser.vue?vue&type=script&lang=js"
export * from "./changeUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports